import React, { memo } from 'react'

import classes from './Collapse.scss'
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
  Grid,
  IconButton
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
const collapse = ({
  show,
  toggleBarClicked,
  title,
  titleComponent,
  style,
  children,
  deletingGroup,
  editingGroup,
  competencyAction,
  effective_date,
  eftdText
}) => {
  let bodyClass = [classes.CollapseBody]

  return (
    <ExpansionPanel expanded={show} onChange={toggleBarClicked}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.Header}>
        {/* <Grid container direction={'row'} justify={'flex-start'} alignItems={'center'}>
        </Grid> */}
        <Grid container direction={'column'} justify={'center'} alignItems={'flex-start'}>
          <Grid item>
            {titleComponent ? titleComponent : <Typography>{title}</Typography>}
          </Grid>
          {show && effective_date ?
            <Grid item>
              <Typography
                variant="subtitle2"
                gutterBottom
              >
                {eftdText} : {effective_date}
              </Typography>
            </Grid> : null
          }
        </Grid>
        {competencyAction ?
          <>
            <IconButton>
              <EditIcon fontSize="small" onClick={editingGroup} />
            </IconButton>
            <IconButton>
              <DeleteIcon fontSize="small"
                onClick={deletingGroup}
              />
            </IconButton>
          </>
          : null
        }
        {/* </Grid> */}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={bodyClass.join(' ')} style={style}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default memo(collapse)
